import { User } from 'oidc-client-ts';

import { storage } from '../oidc-client';

export async function getOidcStorageInfo({
  authority,
  client_id,
}: {
  authority: string;
  client_id: string;
}) {
  if (storage) {
    const oidcStorage = await storage?.get(`user:${authority}:${client_id}`);
    if (oidcStorage) {
      return User.fromStorageString(oidcStorage);
    }
  }
  return null;
}
